import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const salesPaymentService = {
  async getSalesPayments(params = {}) {
    try {
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/sales-payment-master/summary", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getPaymentsBySellingMasterId(sellingMasterId) {
    if (!sellingMasterId) throw new Error("Selling Master ID is required");
    try {
      const response = await apiClient.get(`/sales-payment-master/selling/${sellingMasterId}`);
      const payload = response?.data || {};
      const data = extractData(payload);
      return toArray(data);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getSalesPaymentById(id) {
    if (!id) throw new Error("Payment Transaction ID is required");
    try {
      const response = await apiClient.get(`/sales-payment-master/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createSalesPayment(payload) {
    try {
      let data = payload;
      let headers = {};
      if (payload.attachment) {
        data = new FormData();
        Object.keys(payload).forEach((key) => {
          if (payload[key] !== null && payload[key] !== undefined) {
            data.append(key, payload[key]);
          }
        });
        headers = { "Content-Type": "multipart/form-data" };
      }
      const response = await apiClient.post("/sales-payment-master", data, { headers });
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateSalesPayment(id, payload) {
    if (!id) throw new Error("Payment Transaction ID is required");
    try {
      let data = payload;
      let headers = {};
      if (payload.attachment) {
        data = new FormData();
        Object.keys(payload).forEach((key) => {
          if (payload[key] !== null && payload[key] !== undefined) {
            data.append(key, payload[key]);
          }
        });
        headers = { "Content-Type": "multipart/form-data" };
      }
      const response = await apiClient.patch(`/sales-payment-master/${id}`, data, { headers });
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteSalesPayment(id) {
    if (!id) throw new Error("Payment Transaction ID is required");
    try {
      const response = await apiClient.delete(`/sales-payment-master/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async toggleReceivedStatus(sellingMasterId, isReceived) {
    if (!sellingMasterId) throw new Error("Selling Master ID is required");
    try {
      const response = await apiClient.patch(`/selling-master/${sellingMasterId}`, { isReceived });
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default salesPaymentService;
